import { keys } from 'ramda';
import type { Editor } from 'slate';

import type { AlineTextFormats, ParagraphStyleVariant, Styles } from '../internal';
import { Queries } from '../internal';

const stylesQueries = {
  mergedStyles: (
    editor: Editor,
    paragraphStyleVariant: ParagraphStyleVariant,
    activeFormats: Partial<AlineTextFormats>
  ): Styles => {
    const styleSheet = Queries.activeStyleSheet(editor);
    const oldStyles = styleSheet[paragraphStyleVariant].styles;
    const oldStyleKeys = keys(oldStyles);

    const newStyles = oldStyleKeys.reduce<AlineTextFormats>(
      (stylesObj: AlineTextFormats, styleKey) => {
        if (activeFormats && activeFormats[styleKey]) {
          return {
            // eslint-disable-next-line aline/no-performance-antipatterns
            ...stylesObj,
            [styleKey]: {
              ...oldStyles[styleKey],
              ...activeFormats[styleKey],
              origin: 'INHERITED',
            },
          };
        }

        return stylesObj;
      },
      { ...oldStyles }
    );

    return {
      ...styleSheet[paragraphStyleVariant],
      styles: newStyles,
    };
  },
};

export default stylesQueries;
